import type { NodeId } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface SelectNodesCommand {
  nodeIds: NodeId[];
}

export const selectNodes: GraphCommandFactory<SelectNodesCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      for (const nodeId of command.nodeIds) {
        draft.graph.selectedNodeIds.add(nodeId);
      }
    });
  };
